import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';

const API = 'https://api.sm-media.id';

export default function ArtistReport() {
  const [artists, setArtists] = useState([]);
  const [selectedArtist, setSelectedArtist] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/artists`).then(r => setArtists(r.data || [])).catch(() => {});
  }, []);

  const generateReport = async (artistId) => {
    if (!artistId) { setData(null); return; }
    setLoading(true); setError('');
    try {
      const res = await axios.get(`${API}/api/analytics/youtube?artist_id=${artistId}`);
      setData(res.data);
    } catch (e) {
      setError('Gagal memuat data laporan');
    }
    setLoading(false);
  };

  const handleSelect = (id) => {
    setSelectedArtist(id);
    generateReport(id);
  };

  const artistName = artists.find(a => a.id === selectedArtist)?.name || '';
  const formatNum = (n) => Number(n || 0).toLocaleString('id-ID');
  const today = new Date().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div style={{ paddingBottom: 40 }}>
      <style>{`
        @media print {
          body * { visibility: hidden; }
          #report-print, #report-print * { visibility: visible; }
          #report-print { position: absolute; left: 0; top: 0; width: 100%; }
          .no-print { display: none !important; }
        }
      `}</style>

      <div className="no-print" style={{ marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 8 }}>
          <i className="ti ti-file-report" style={{ fontSize: 22 }}></i>Laporan Artis
        </h1>
        <p style={{ fontSize: 13, color: colors.textSecondary, marginTop: 2 }}>Ringkasan performa siap dibagikan ke artis atau label.</p>
      </div>

      <div className="no-print" style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap', alignItems: 'center' }}>
        <select value={selectedArtist} onChange={e => handleSelect(e.target.value)} style={{ flex: 1, minWidth: 200 }}>
          <option value="">-- Pilih Artis --</option>
          {artists.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
        {data && (
          <button onClick={() => window.print()} className="btn btn-gold" style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
            <i className="ti ti-printer" style={{ fontSize: 15 }}></i>Cetak / Simpan PDF
          </button>
        )}
      </div>

      {error && (
        <div className="no-print" style={{ padding: '10px 14px', background: colors.dangerMuted, color: colors.danger, borderRadius: radius.md, marginBottom: 16, fontSize: 13 }}>{error}</div>
      )}

      {loading && (
        <div style={{ textAlign: 'center', padding: 40, color: colors.textSecondary }}>Menyusun laporan...</div>
      )}

      {!loading && !selectedArtist && (
        <div style={{ textAlign: 'center', padding: 60, color: colors.textSecondary, background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg }}>
          <i className="ti ti-file-report" style={{ fontSize: 40, marginBottom: 10, display: 'block' }}></i>
          Pilih artis di atas untuk menyusun laporan performa.
        </div>
      )}

      {!loading && data && (
        <div id="report-print" style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 28 }}>
          <div style={{ textAlign: 'center', marginBottom: 24, paddingBottom: 20, borderBottom: `2px solid ${colors.border}` }}>
            <div style={{ fontSize: 12, color: colors.textSecondary, letterSpacing: 1, textTransform: 'uppercase' }}>Laporan Performa</div>
            <h2 style={{ fontSize: 26, fontWeight: 800, color: colors.textPrimary, margin: '6px 0' }}>{artistName}</h2>
            <div style={{ fontSize: 12, color: colors.textSecondary }}>Disusun pada {today} · SM Media</div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 28 }}>
            {[
              { label: 'Total Views', value: data.totals.views, icon: 'ti-eye' },
              { label: 'Total Likes', value: data.totals.likes, icon: 'ti-thumb-up' },
              { label: 'Total Komentar', value: data.totals.comments, icon: 'ti-message-circle' },
              { label: 'Total Video', value: data.totals.videos, icon: 'ti-video' },
            ].map(s => (
              <div key={s.label} style={{ textAlign: 'center', padding: 14, background: colors.bgCardMuted, borderRadius: radius.md }}>
                <i className={`ti ${s.icon}`} style={{ fontSize: 18, color: colors.accent }}></i>
                <div style={{ fontSize: 20, fontWeight: 700, color: colors.textPrimary, marginTop: 4 }}>{formatNum(s.value)}</div>
                <div style={{ fontSize: 10, color: colors.textSecondary, marginTop: 2 }}>{s.label}</div>
              </div>
            ))}
          </div>

          {data.best_hour && (
            <div style={{ padding: 14, background: colors.accentMuted, borderRadius: radius.md, marginBottom: 24, fontSize: 12, color: colors.accentText }}>
              <i className="ti ti-bulb" style={{ fontSize: 14, marginRight: 6 }}></i>
              Waktu upload terbaik berdasarkan data: <strong>{String(data.best_hour.hour).padStart(2, '0')}:00 WIB</strong> (rata-rata {formatNum(data.best_hour.avg_views)} views)
            </div>
          )}

          <div style={{ fontSize: 14, fontWeight: 700, color: colors.textPrimary, marginBottom: 12 }}>Performa per Channel</div>
          {data.channels.length === 0 ? (
            <div style={{ fontSize: 12, color: colors.textSecondary, padding: '20px 0', textAlign: 'center' }}>Belum ada channel yang ter-assign ke artis ini.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ borderBottom: `2px solid ${colors.border}`, textAlign: 'left' }}>
                  <th style={{ padding: '8px 6px', color: colors.textSecondary }}>Channel</th>
                  <th style={{ padding: '8px 6px', color: colors.textSecondary, textAlign: 'right' }}>Views</th>
                  <th style={{ padding: '8px 6px', color: colors.textSecondary, textAlign: 'right' }}>Likes</th>
                  <th style={{ padding: '8px 6px', color: colors.textSecondary, textAlign: 'right' }}>Komentar</th>
                  <th style={{ padding: '8px 6px', color: colors.textSecondary, textAlign: 'right' }}>Video</th>
                </tr>
              </thead>
              <tbody>
                {data.channels.map(ch => (
                  <tr key={ch.channel_id} style={{ borderBottom: `1px solid ${colors.border}` }}>
                    <td style={{ padding: '8px 6px', color: colors.textPrimary, fontWeight: 600 }}>{ch.channel_name}</td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', color: colors.textPrimary }}>{formatNum(ch.views)}</td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', color: colors.textPrimary }}>{formatNum(ch.likes)}</td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', color: colors.textPrimary }}>{formatNum(ch.comments)}</td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', color: colors.textPrimary }}>{ch.videos}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <div style={{ marginTop: 28, paddingTop: 16, borderTop: `1px solid ${colors.border}`, fontSize: 10, color: colors.textSecondary, textAlign: 'center' }}>
            Laporan ini dibuat otomatis oleh sistem SM Media, mencakup video yang diupload melalui platform.
          </div>
        </div>
      )}
    </div>
  );
}
